if (!customElements.get('gopuff-categories-carousel')) {
  class GopuffCategoriesCarousel extends HTMLElement {
    constructor() {
      super();
      this.loading = false;
      this.categories = [];
      this.breinifyRecommenderIds = {
        'DEFAULT': this.getAttribute(`breinify-recommender-id`),
        'AZ': this.getAttribute(`breinify-recommender-id-az`),
        'WA':this.getAttribute(`breinify-recommender-id-wa`),
      };

      this.classList.add(`gopuff-categories-carousel`);
      subscribe(PUB_SUB_EVENTS.bevmoLocationUpdate, () => {
        this.loadCategories();
      });
    }

    async getBreinifyCategoryRecommendations() {
      if (!this.breinifyRecommenderId) { return []; }

      const cart = await document.querySelector(`cart-drawer-items`).getCartJSON();
      const inCartGopuffSkus = cart.items.map((item) => {
        if (!item.sku) { return ``; }

        const gopuffSku = item.sku.split(`_`)[2];

        return gopuffSku;
      }).filter(Boolean);

      const recommendationParams = {
        namedRecommendations: [this.breinifyRecommenderId],
        recommendationQueryName: this.breinifyRecommenderId,
        recommendationForItems: inCartGopuffSkus,
      };

      const { result: results } = await window.gopuffBreinify.getRecommendations(recommendationParams);

      if (!results) { return []; }

      const categoryRecommendations = results.map((result) => {
        if (!result.additionalData) { return; }
        
        return {
          image: {
            src: [result.additionalData[`assets::assetImageUrl`]],
            alt: ``,
          },
          title: result.additionalData[`assets::assetTitle`],
          url: result.additionalData[`assets::assetUrl`]
        };
      }).filter(Boolean);

      return categoryRecommendations;
    }

    async getGopuffCategories() {
      if (this.breinifyRecommenderId) {
        return await this.getBreinifyCategoryRecommendations();
      }

      return [];
    }

    getLoadingContent(placeholders_count = 6) {
      const loading_content = new DocumentFragment();

      for (let i = 0; i < placeholders_count; i++) {
        const placeholder_item = document.createElement(`li`);
        const placeholder_content = document.createElement(`div`);
        placeholder_item.classList.add(`grid__item`, `grid__item--placeholder`, `slider__slide`);
        placeholder_content.classList.add(`skeleton-box`);

        placeholder_item.appendChild(placeholder_content);
        loading_content.appendChild(placeholder_item);
      }

      return loading_content;
    }

    setLoading(isLoading = true) {
      this.classList.toggle(`gopuff-categories-carousel--loading`, isLoading);
      this.loading = isLoading;
    }

    renderCarousel() {
      const slides = new DocumentFragment();
      const slide_template = this.querySelector(`[data-slide-template]`);

      if (this.categories.length === 0 && this.loading) {
        slides.appendChild(this.getLoadingContent());
      }

      this.categories.forEach((category, category_index) => {
        const slide = slide_template.content.cloneNode(true);

        const updated_slide = modifyHTML(slide, (html_string) => {
          html_string = html_string.split(`[[ forloop_index ]]`).join(category_index);

          return html_string;
        });

        slides.appendChild(updated_slide);
      });

      const carousel = this.querySelector(`[data-carousel-template]`).content.cloneNode(true);
      carousel.querySelector(`[data-categories-carousel-categories]`).appendChild(slides);
      this.querySelector(`[data-carousel-main]`).innerHTML = ``;
      this.querySelector(`[data-carousel-main]`).appendChild(carousel);

      this.querySelectorAll(`card-category`).forEach((card_category, category_index) => {
        card_category.setCategory(this.categories[category_index]);
      });
      
      const section = this.closest('.section');
      if (section.classList.contains('hidden')) {
        section.classList.remove('hidden');
      }
    }

    renderEmpty() {
      this.querySelector(`[data-carousel-main]`).innerHTML = `<div class="gopuff-categories-carousel__empty">Sorry, we couldn't find any categories</div>`;
    }

    async loadCategories() {
      const storefrontLocation = window.bevmoLocation.storefrontLocation || `DEFAULT`;
      this.breinifyRecommenderId = this.breinifyRecommenderIds[storefrontLocation];
      this.categories = [];
      this.setLoading();
      this.renderCarousel();
      this.categories = await this.getGopuffCategories();

      if (this.categories.length === 0) {
        this.renderEmpty();
      } else {
        this.renderCarousel();
      }

      this.setLoading(false);
    }

    connectedCallback() {
      this.loadCategories();
    }
  }

  customElements.define(`gopuff-categories-carousel`, GopuffCategoriesCarousel);
}
